import { TrackEventEnum } from "@/store/logging/types";
import { RootStore } from "@/store/root";
import { makeAutoObservable } from "mobx";

export class PopupStore {
  private _rootStore: RootStore;

  private _promote = false;
  private _pro = false;

  private _expenseCategoriesLimit = false;
  private _incomeSourcesLimit = false;
  private _savingsLimit = false;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;

    makeAutoObservable(this);
  }

  public set promote(value: boolean) {
    this._promote = value;
  }

  public get promote(): boolean {
    return this._promote;
  }

  public set pro(value: boolean) {
    this._pro = value;
  }

  public get pro(): boolean {
    return this._pro;
  }

  public set expenseCategoriesLimit(value: boolean) {
    this._expenseCategoriesLimit = value;

    this._rootStore.logging.track(
      value ? TrackEventEnum.PRO_POPUP_SHOWN : TrackEventEnum.PRO_POPUP_HIDDEN
    );
  }

  public get expenseCategoriesLimit(): boolean {
    return this._expenseCategoriesLimit;
  }

  public set incomeSourcesLimit(value: boolean) {
    this._incomeSourcesLimit = value;

    this._rootStore.logging.track(
      value ? TrackEventEnum.PRO_POPUP_SHOWN : TrackEventEnum.PRO_POPUP_HIDDEN
    );
  }

  public get incomeSourcesLimit(): boolean {
    return this._incomeSourcesLimit;
  }

  public set savingsLimit(value: boolean) {
    this._savingsLimit = value;

    this._rootStore.logging.track(
      value ? TrackEventEnum.PRO_POPUP_SHOWN : TrackEventEnum.PRO_POPUP_HIDDEN
    );
  }

  public get savingsLimit(): boolean {
    return this._savingsLimit;
  }

  public close = (): void => {
    this._expenseCategoriesLimit = false;
    this._incomeSourcesLimit = false;
    this._savingsLimit = false;
  };

  public load = async (): Promise<void> => {};

  public togglePromote = (): void => {
    this._promote = !this._promote;
  };

  public togglePro = (): void => {
    this._pro = !this._pro;
  };
}
